<nav class="book-header">

    <div class="left-header">

        <a routerLink="">
            <img [src]="getSafeUrl()" alt="client logo">
        </a>

        <div class="header-name">
            {{headerTitle}}
        </div>
        <span *ngIf="userRole" class="roleTag">{{userRole | uppercase}}</span>
    </div>
    <div class="right-nav-wrapper">

        <div class="right-header">
            <div class="toggle-group">
                <div *ngIf="bulkBookingConfig?bulkBookingConfig:false" (click)="clickedBulk()" class="bulk-book " >
                    <div>
                        <img class="add-sign" src="../../../assets/bulk.svg" alt="">
                    </div>
                    <div>
                        Bulk Booking
                    </div>

                </div>
                <div *ngIf="showCreateBookingButton" class="ml-24">
                    <div *ngIf="createBookingConfig?createBookingConfig:   false" (click)="clickedCreate()" class="bulk-book clickedCreate">
                        <div >
                            <img class="add-sign" src="../../../assets/addRider.svg" alt="">
                        </div>
                        <div>
                            Create Booking 

                        </div>
                    </div>
                </div>
            </div>

            <!-- notification.svg -->
            <div class="avators">
                <div class=" mt-5 relative">

                    <app-dropdown xPosition="right">
                        <div dropdown-trigger class="relative"  >
                            <div>
                                <span class="count-over-icon bg-e84822" [ngClass]="notificationCount > 99 ? 'big-count': ''" *ngIf="notificationCount">{{ notificationCount > 99 ? '99+' : notificationCount }}</span>
                                    <!-- {{createBookingList.length > 99 ? createBookingList.length +'+' : createBookingList.length}} -->
                                <img src="assets/images/notification.svg" class="cursor-pointer">
                            </div>
                        </div>
                        <div dropdown-menu class="profile-menu notification">

                            <ng-container *ngIf="notificationConfig?.showVendorAssignmentNotification">
                                <div class="relative" *ngIf="createBookingList?.length" [matTooltip]="createBookingList.length === 1 ? 
                                    createBookingList.length +' booking needs Vendor Assignment' : 
                                    createBookingList.length + ' bookings need Vendor Assignment'"
                                    [matTooltipClass]="'notification-tooltip'" matTooltipPosition="right"
                                    (click)="navigateToBooking(createBookingList, 'createBooking')">

                                    <!-- <span *ngIf="createBookingList.length"
                                        class="count-over-icon bg-e84822">{{createBookingList.length > 99 ?
                                        createBookingList.length
                                        +'+' : createBookingList.length}}</span> -->
                                    <!-- <img src="assets/images/notification.svg" class="cursor-pointer"> -->
                                    <span>Vendor Assignment</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="notificationConfig?.showVendorAcceptanceNotification">
                                <div *ngIf="vendorBookingList?.length" class="relative" [matTooltip]="vendorBookingList.length === 1 ?
                              vendorBookingList.length + ' booking needs Vendor Acknowledgement' :
                              vendorBookingList.length + ' bookings need Vendor Acknowledgement'"
                                    [matTooltipClass]="'notification-tooltip'" matTooltipPosition="right"
                                    (click)="navigateToBooking(vendorBookingList, 'vendorBooking')">
                                    <!-- <span class="count-over-icon bg-e84822"></span> -->
                                    <!-- <img src="assets/images/notification.svg" class="cursor-pointer"> -->
                                    <span>Vendor Acknowledgement</span>
                                </div>
                            </ng-container>
                                <div *ngIf="!(cabAllocBookingList?.length || vendorBookingList?.length|| createBookingList?.length)">
                                   No notification
                                  </div>
                            <ng-container *ngIf="notificationConfig?.showCabAllocationNotification">
                                <div class="relative" *ngIf="cabAllocBookingList?.length" [matTooltip]="cabAllocBookingList.length === 1 ? 
                              cabAllocBookingList.length +' booking needs Cab Allocation' :
                              cabAllocBookingList.length +' bookings need Cab Allocation'"
                                    [matTooltipClass]="'notification-tooltip'" matTooltipPosition="right"
                                    (click)="navigateToBooking(cabAllocBookingList, 'cabAllocation')">
                                    <!-- <span class="count-over-icon bg-e84822"
                                        style="top: -16px"></span> -->

                                    <span>Cab Allocation</span>
                                    <!-- <img src="assets/images/notification.svg" class="cursor-pointer"> -->
                                </div>
                            </ng-container>
                        </div>
                    </app-dropdown>
                </div>


            </div>
        </div>

        <app-dropdown xPosition="right">
            <div dropdown-trigger class="mt-5 user-avatar">
                <div>
                    <img src="../../../../../assets/images/avatar.svg" alt="">
                </div>
            </div>
            <div dropdown-menu class="profile-menu">
                <div class="logged-user" *ngIf="authService.isAuthenticated() && authService.user.info">
                    <div class="email" >
                        {{authService.user.info.employee.employeeName || authService.user.info.employee.emailId}}
                    </div>
                    <div class="seperator"></div> 
                    <div class="logged-in" (click)="navigateToEts()">My Profile</div>
                    <div class="profile-menu-item option" style="cursor: pointer;" (click)="handleUserLogout()">Log out
                    </div>
                </div>
               
            </div>
        </app-dropdown>

    </div>
</nav>
<app-popover [size]="'policypopup'" [policyPopup]="true" *ngIf="openPolicyPopup" (closeCallback)="openPolicyPopup=false">
    <div popover-header class="error-header">
        <span>{{policyData.title===''?'Travel Policies':policyData.title}}</span>
    </div>
    <div popover-content class="popup-wrapper">
        <app-select [showClear]="true" [config]="{displayName:'Select city'}" [type]="'dropdown'" [formControl]="city"
            [options]="cityList">
        </app-select>
        <div class="policypopup-body">
            <div class="empty-policy" *ngIf="policyData.policy==='';else elseBlock">
                <img src="assets/emptyPolicy.svg" alt="">
                <span>Please select city to read the policies</span>
            </div>
            <ng-template #elseBlock><span [innerHTML]="policyData.policy"></span></ng-template>
        </div>
    </div>
    <div popover-actions>
        <app-button type="save-button" text="Accept" (clickCallback)="onPolicyAccept()" [ngClass]="city.status==='INVALID'?'disable':''"></app-button>
    </div>
</app-popover>

